module.exports = __webpack_public_path__ + "564f210a7fffe561e9ea54bc82311c8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/samsung_gear_connect/img-gear.png
// module id = 1840
// module chunks = 1